import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';

// Which attendance channels count for a role. Manual attendance is always
// allowed regardless of the mode — only biometric and app self check-in vary.
export const ATTENDANCE_MODES = [
    {
        key: 'hybrid',
        label: 'Hybrid',
        short: 'Biometric + app',
        description: 'Biometric punches and app self check-in both count.',
        icon: DevicesRoundedIcon,
        color: '#135F93',
        bg: '#E4F0F9',
        border: '#B3D3E8',
    },
    {
        key: 'wfh',
        label: 'Work from home',
        short: 'App only',
        description: 'App self check-in only — biometric punches are skipped.',
        icon: HomeWorkRoundedIcon,
        color: '#0891B2',
        bg: '#ECFEFF',
        border: '#A5E9F2',
    },
    {
        key: 'wfo',
        label: 'Work from office',
        short: 'Biometric only',
        description: 'Biometric punches only — app self check-in is blocked.',
        icon: ApartmentRoundedIcon,
        color: '#B45309',
        bg: '#FFF7ED',
        border: '#F6E0C2',
    },
];

export const DEFAULT_ATTENDANCE_MODE = 'hybrid';

export const attendanceModeOf = (key) =>
    ATTENDANCE_MODES.find((m) => m.key === String(key || '').toLowerCase()) || ATTENDANCE_MODES[0];
